import { z } from "zod";

export const getActiveAbsencesQuerySchema = z.object({
	date: z.string().optional(),
});

export type GetActiveAbsencesQuerySchema = z.infer<typeof getActiveAbsencesQuerySchema>;
